import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingPageLineActivationInflowSourceFormAssignedStaffFragmentDoc } from './SettingPageLineActivationInflowSourceFormAssignedStaff.generated';
export type SettingPageLineActivationInflowSourceFormQueryFragment = { __typename?: 'Query', staffsByPlanner: Array<{ __typename?: 'Staff', guid: string, displayName: string }> };

export const SettingPageLineActivationInflowSourceFormQueryFragmentDoc = gql`
    fragment SettingPageLineActivationInflowSourceFormQuery on Query {
  staffsByPlanner {
    ...SettingPageLineActivationInflowSourceFormAssignedStaff
  }
}
    ${SettingPageLineActivationInflowSourceFormAssignedStaffFragmentDoc}`;